var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDog409(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#f9f7e1;}.cls-2,.cls-3{stroke:#333;stroke-miterlimit:10;stroke-width:2px;}.cls-3{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_409"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_409",
    "data-name": 409,
    className: "cls-2",
    d: "M35.46,1.79c-8.15,2.19-9,31.41-3.93,51.78,2.45,9.9,6.08,20,11.85,28.59a42.85,42.85,0,0,0,10.9,11.48c1.38,1,10.56,6.8,15,3.56,2.34-1.71,2.41-5.24,2.44-8.41.12-16.56-1.17-33.46-6.31-49.29a80.91,80.91,0,0,0-11-22.3C51.2,12.72,42.11,0,35.46,1.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "detail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crevice",
    className: "cls-3",
    d: "M38.05,22.12A66.79,66.79,0,0,0,44.4,33.51,65.14,65.14,0,0,0,56.33,46.57a93,93,0,0,0-.81,14.15A94.22,94.22,0,0,0,58,80.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crevice-2",
    "data-name": "crevice",
    className: "cls-3",
    d: "M38.05,22.12A66.79,66.79,0,0,0,44.4,33.51,65.14,65.14,0,0,0,56.33,46.57a93,93,0,0,0-.81,14.15A94.22,94.22,0,0,0,58,80.44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog409);
export default __webpack_public_path__ + "static/media/dog_409.5aedf0378dc52ad5035f56733cf88aea.svg";
export { ForwardRef as ReactComponent };